import { ErrorResponse, LegacyList } from 'interfaces'

import assert from 'services/errors'
import { List } from 'shared'

export function listAdapter(list: LegacyList, connectedPageIds: string[], index: number): List {
  const pages = list.postDestinations || []
  const parsedOrder = list.order ? parseInt(list.order, 10) : NaN
  const order = isNaN(parsedOrder) ? index : parsedOrder
  return {
    id: list.id.toString(),
    teamId: list.appId.toString(),
    name: list.listName,
    pages,
    order,
    connectedPages: pages.filter((id: string) => connectedPageIds.includes(id))
  }
}

export function listsAdapter(response: LegacyList[] | ErrorResponse, connectedPageIds: string[]): List[] {
  const listsResponse = assert<LegacyList[]>(response)

  return listsResponse.map((response, index) => listAdapter(response, connectedPageIds, index))
}
